module.exports = __webpack_public_path__ + "img/icon_rar.852356bd.png";